export const iceServers = [
    { urls: 'stun:turn.controlhub.virtualsafetylab.com:3478' },
    {
      urls: 'turns:turn.controlhub.virtualsafetylab.com:5349',
      username: 'testuser',
      credential: 'testpassword',
    },
  ];
  